import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FormCategory from './form/formCategory';
import { useTranslationsContext } from './context/TranslationsContext';
import request from './utils/request';
import ValidateLoader from './UI/validateLoader';
import {
  PERMISSIONS,
  categoryFormIds as formIds,
  CONSTANT,
  categoryFormKeys,
  formCategoryWirelineSecureBusiness,
  formCategoryReferrals,
  categoryWireless,
  formCategoryBrp,
  formCategoryNames,
  categoryVulcan,
  formCategoryFM,
  hideFormCategories,
  showFormForEmail
} from './utils/constant';

const Dashboard = ({ categories, locale, history }) => {
  const translations = useTranslationsContext();
  const { getProfile } = request;
  const profile = getProfile();
  const permissions = profile ? PERMISSIONS[profile.role.name] : undefined;
  const { role: { name: roleName = 'none' } = {} } = profile || {};
  const { channel = {} } = profile || {};
  const {
    DASHBOARD: {
      dashboardHeadingTitle,
      dashboardDescription,
      applicationDashboard
    }
  } = translations;

  const [formFreezeStatus, setFormFreezeStatus] = useState({});
  const [loading, setLoading] = useState(false);
  const {
    KEYS: {
      ROLES: { ADMIN }
    }
  } = CONSTANT;
  const isAdmin = roleName === ADMIN;

  const getFormFreezeDetails = async () => {
    setLoading(true);
    try {
      const [
        {
          data: { value: orderVal }
        },
        {
          data: { value: referalVal }
        },
        {
          data: { value: wirelessVal }
        },
        {
          data: { value: brpVal }
        },
        {
          data: { value: vulVal }
        },
        {
          data: { value: fmVal }
        }
      ] = [
        await request.get(`/options/${formIds[categoryFormKeys.ORDER]}`),
        await request.get(`/options/${formIds[categoryFormKeys.REFERRAL]}`),
        await request.get(`/options/${formIds[categoryFormKeys.WIRELESS]}`),
        await request.get(`/options/${formIds[categoryFormKeys.BRP]}`),
        await request.get(`/options/${formIds[categoryFormKeys.VULCAN]}`),
        await request.get(`/options/${formIds[categoryFormKeys.FM]}`)
      ];
      const statusResponse = {
        [formCategoryNames.wirelineAndSecureBusinessForm]: JSON.parse(orderVal),
        [formCategoryNames.referrals]: JSON.parse(referalVal),
        [formCategoryNames.wireless]: JSON.parse(wirelessVal),
        [formCategoryNames.brpForm]: JSON.parse(brpVal),
        [formCategoryNames.vulForm]: JSON.parse(vulVal),
        [formCategoryNames.fmForm]: JSON.parse(fmVal)
      };
      setFormFreezeStatus(statusResponse);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    // remove the property once formstep has consumed it
    localStorage.removeItem('province');
    localStorage.setItem('flow', 0);
    getFormFreezeDetails();
  }, []);

  const checkAllowedCategories = (fieldName, channelObj = '') => {
    if (channelObj && channelObj.name) {
      if (
        fieldName === formCategoryWirelineSecureBusiness &&
        channelObj.name === permissions.channels.name
      ) {
        return false;
      }
      if (
        fieldName === formCategoryReferrals &&
        channelObj.name === permissions.channels.name
      ) {
        return true;
      }
    }
    return permissions[fieldName];
  };

  const isCurrentFormIsRetricted = fieldName => {
    if (
      fieldName === formCategoryWirelineSecureBusiness &&
      profile.formTypes &&
      profile.formTypes.disableWireline
    ) {
      return true;
    }
    if (
      fieldName === formCategoryReferrals &&
      profile.formTypes &&
      profile.formTypes.disableReferral
    ) {
      return true;
    }
    if (
      fieldName === categoryWireless &&
      profile.formTypes &&
      profile.formTypes.disableWireless
    ) {
      return true;
    }
    if (
      fieldName === categoryVulcan &&
      profile.formTypes &&
      profile.formTypes.disableVulcan
    ) {
      return true;
    }
    if (
      fieldName === formCategoryBrp &&
      profile.formTypes &&
      profile.formTypes.disableBrp
    ) {
      return true;
    }
    if (
      fieldName === formCategoryFM &&
      profile.formTypes &&
      profile.formTypes.disableFM
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div style={{ backgroundColor: '#ffffff', paddingBottom: '3em' }}>
        <div className="dashboard-container 5%">
          <div id="title" style={{ paddingTop: '2em' }}>
            <h2>{dashboardHeadingTitle}</h2>
            <p>{dashboardDescription}</p>
          </div>

          <div
            style={{
              border: '1px solid #e2e2e2',
              boxShadow: '0px 5px 5px #dedede'
            }}
          >
            <h4
              style={{
                width: '100%',
                padding: '10px 15px',
                backgroundColor: 'rgb(75, 40, 109)',
                color: '#ffffff'
              }}
            >
              {applicationDashboard}
            </h4>
            {loading ? (
              <ValidateLoader message="Loading" />
            ) : roleName !== 'none' ? (
              <>
                {(() => {
                  let allowedRowNumber = 0;
                  return categories.map(({ fields }, index) => {
                    if (
                      hideFormCategories.includes(fields.name) &&
                      !showFormForEmail.includes(profile.email)
                    ) {
                      return;
                    }
                    const key = `category${index}`;
                    if (checkAllowedCategories(fields.name, channel)) {
                      allowedRowNumber += 1;
                      return (
                        <FormCategory
                          key={key}
                          row={allowedRowNumber}
                          category={fields}
                          locale={locale}
                          history={history}
                          isFreezed={
                            isAdmin
                              ? false
                              : formFreezeStatus[fields.name] ||
                                isCurrentFormIsRetricted(fields.name)
                          }
                        />
                      );
                    }
                    return null;
                  });
                })()}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

Dashboard.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({})
    })
  ).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default Dashboard;
